import {
  useState,
  useEffect,
  useRef,
  Suspense,
  useCallback,
  useContext,
} from "react";
import { useFormik } from "formik";
import {
  addSurveyForm,
  deleteSurveyQuestions,
  getSurveyList, addSurveyFormQuestion
} from "./Services/surveyService";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { publishUnpublishSurveyForm } from "./Services/surveyService";
import { useHistory } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import * as Yup from "yup";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { Link } from "react-router-dom";

const CreateSurvay = () => {
  const [surveyOptionType, setSurveyOptionType] = useState([]);
  const history = useHistory();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const { SurveyFormId } = useParams();
  const [isRequired, setIsRequired] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const [surveyStatus, setSurveyStatus] = useState(0);
  const [isPublishing, setIsPublishing] = useState(false);
  const [surveyFormId, setSurveyFormId] = useState(null);
  const [surveyFormGuid, setSurveyFormGuid] = useState(null);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [activeIndex, setActiveIndex] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [lastEditedQuestionId, setLastEditedQuestionId] = useState(null);
  const [isEditing, setIsEditing] = useState(true);
  const surveyWrapperRef = useRef(null);
  const surveyRowRef = useRef(null);
  const saveTimeoutRef = useRef(null);
  const isSavingRef = useRef(false);
  const toster = useContext(TostMsg);
  const formRef = useRef(null);
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);

  const optionKeyByType = {
    101: "optionsCheckbox",
    102: "optionsRadio",
    103: "optionsDropdown",
    104: "optionsInput",
  };


  useEffect(() => {
    getMasterSurveyOptionsType();
    permissionAccouncementList();
    
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Survey.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Survey.Manage") {
        setUpdate(true);
      }
    });
  };

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };


  const debouncedSaveQuestion = useCallback(
    debounce(async (question) => {
      if (!question || !surveyFormId) return;
      await saveSingleQuestion(question);
    }, 900),
    [surveyFormId],
  );

  const saveSingleQuestion = async (question) => {
    if (!surveyFormId || !question.isDirty) return;

    const optionKey = optionKeyByType[question.type];
    const options = (question[optionKey] || [])
      .filter((o) => o?.trim())
      .map((text, i) => ({
        OrgId: userDetails.OrgId,
        OptionText: text.trim(),
        OptionOrder: i + 1,
      }));

    const payload = {
      QuestionId: question.serverId || 0,
      FormId: surveyFormId,
      OrgId: userDetails.OrgId,
      QuesOrderId: question.order,
      QuestionTitle: question.title || "Untitled question",
      QuestionType: question.type,
      IsMandatory: question.required,
      Options: options,
    };

    const res = await addSurveyFormQuestion(payload);

    setQuestions((prev) =>
      prev.map((q) =>
        q.id === question.id
          ? {
            ...q,
            serverId: q.serverId || res?.Data?.QuestionId,
            isDirty: false,
          }
          : q,
      ),
    );
  };
  useEffect(() => {
    if (!SurveyFormId) {
      setQuestions([getEmptyQuestion()]);
      return;
    }
    loadExistingSurvey();
  }, [SurveyFormId]);

  const loadExistingSurvey = async () => {
    setIsloading(true);
    try {
      const params = {
        FormId: 0,
        PageNumber: 1,
        PageSize: 10000,
        EmpId: userDetails.OrgId,
        MyCreatedSurvey: 0,
        MyParticipation: 0,
        EmpGUID: "",
        FormGUID: SurveyFormId || surveyFormGuid,
        Search: ""
      };

      const response = await getSurveyList(params);
      const formData = response?.Data?.[0];

      if (formData) {
        setSurveyFormId(formData.FormId);
        setSurveyFormGuid(formData.FormGUID);
        setSurveyStatus(formData.IsPublished);
        surveyForm.setValues({
          Title: formData.Title || "",
          Desc: formData.Description || "",
          ClosureDate: formData.ClosureDate
            ? getValidDate(formData.ClosureDate)
            : new Date(),
        });
        const loadedQuestions = formData.Questions.map((qApi) => {
          const typeNum = Number(qApi.QuestionType);
          const optKey = optionKeyByType[typeNum] || "optionsInput";

          return {
            id: `server-${qApi.QuestionId}`,
            serverId: qApi.QuestionId,
            type: typeNum,
            typeString: "",
            required: qApi.IsMandatory || false,
            title: qApi.QuestionTitle || "",
            order: qApi.QuesOrderId + 1 || 1,
            optionsCheckbox:
              typeNum === 101 ? qApi.Options.map((o) => o.OptionText) : [""],
            optionsRadio:
              typeNum === 102 ? qApi.Options.map((o) => o.OptionText) : [""],
            optionsDropdown:
              typeNum === 103 ? qApi.Options.map((o) => o.OptionText) : [""],
            optionsInput:
              typeNum === 104 ? qApi.Options.map((o) => o.OptionText) : [""],
          };
        });
        setIsEditing(false);
        setQuestions(
          loadedQuestions.length > 0 ? loadedQuestions : [getEmptyQuestion()],
        );
      }
    } catch (err) {
      console.error("Failed to load survey", err);
    } finally {
      setIsloading(false);
    }
  };


  const getEmptyQuestion = () => ({
    id: `client-${Date.now()}-${Math.random()}`,
    serverId: 0,
    type: 102,
    typeString: "",
    required: false,
    title: "",
    order: questions.length + 1,
    optionsCheckbox: [""],
    optionsRadio: [""],
    optionsDropdown: [""],
    optionsInput: [""],
    isDirty: true,
  });

  const reIndexQuestions = (list) =>
    list.map((q, index) => ({
      ...q,
      order: index + 1,
    }));
  const updateQuestion = (id, key, value) => {
    setQuestions((prev) =>
      prev.map((q) =>
        q.id === id ? { ...q, [key]: value, isDirty: true } : q,
      ),
    );
    setLastEditedQuestionId(id);
  };

  const updateOption = (qid, idx, value, key) => {
    setQuestions((prev) =>
      prev.map((q) =>
        q.id === qid
          ? {
            ...q,
            [key]: q[key].map((o, i) => (i === idx ? value : o)),
            isDirty: true,
          }
          : q,
      ),
    );
    setLastEditedQuestionId(qid);
  };

  const handleDeleteQuestion = (index, QId) => {
    setQuestions((prev) =>
      reIndexQuestions(prev.filter((_, i) => i !== index)),
    );
    setLastEditedQuestionId(null);
    if (QId?.serverId) {
      DeleteSurveyForm(QId);
    }
  };

  async function DeleteSurveyForm(QId) {
    let body = {
      Id: QId?.serverId,
    };
    try {
      await deleteSurveyQuestions(body);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }
  const moveQuestionDown = (index) => {
    setQuestions((prev) => {
      if (index === prev.length - 1) return prev;
      const updated = [...prev];
      [updated[index + 1], updated[index]] = [
        updated[index],
        updated[index + 1],
      ];
      return reIndexQuestions(updated);
    });
  };

  const moveQuestionUp = (index) => {
    setQuestions((prev) => {
      if (index === 0) return prev;
      const updated = [...prev];
      [updated[index - 1], updated[index]] = [
        updated[index],
        updated[index - 1],
      ];
      return reIndexQuestions(updated);
    });
  };

  const handleAddNewQuestion = async () => {
    await saveSurvey();
    addNewQuestion();
  };
  const addNewQuestion = () => {
    setQuestions((prev) =>
      reIndexQuestions([
        ...prev,
        {
          ...getEmptyQuestion(),
          order: prev.length + 1,
        },
      ]),
    );
  };

  const copyQuestion = (index) => {
    setQuestions((prev) => {
      const copied = { ...prev[index], id: Date.now(), serverId: 0 };
      const updated = [...prev];
      updated.splice(index + 1, 0, copied);
      return reIndexQuestions(updated);
    });
  };

  async function getMasterSurveyOptionsType() {
    setIsloading(true);
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "QuestionType",
    };
    try {
      const data = await GetMasterTypeData(params);
      setSurveyOptionType(data?.Data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsloading(false);
    }
  }

  const updateOptionCheckbox = (questionIndex, optionIndex, value) => {
    setQuestions((prev) => {
      const updated = [...prev];
      const options = [...updated[questionIndex].optionsCheckbox];
      options[optionIndex] = value;
      updated[questionIndex] = {
        ...updated[questionIndex],
        optionsCheckbox: options,
      };
      return updated;
    });
  };

  const updateOptionRadio = (questionIndex, optionIndex, value) => {
    setQuestions((prev) => {
      const updated = [...prev];
      const options = [...updated[questionIndex].optionsRadio];
      options[optionIndex] = value;
      updated[questionIndex] = {
        ...updated[questionIndex],
        optionsRadio: options,
      };
      return updated;
    });
  };

  const updateOptionDropdown = (questionIndex, optionIndex, value) => {
    setQuestions((prev) => {
      const updated = [...prev];
      const options = [...updated[questionIndex].optionsDropdown];

      options[optionIndex] = value;

      updated[questionIndex] = {
        ...updated[questionIndex],
        optionsDropdown: options,
      };

      return updated;
    });
  };

  const updateOptionInput = (questionIndex, optionIndex, value) => {
    setQuestions((prev) => {
      const updated = [...prev];
      const options = [...updated[questionIndex].optionsInput];

      options[optionIndex] = value;

      updated[questionIndex] = {
        ...updated[questionIndex],
        optionsInput: options,
      };

      return updated;
    });
  };

  const moveOptionUp = (questionIndex, optionIndex, key) => {
    if (optionIndex === 0) return;
    setQuestions((prev) => {
      const updated = [...prev];
      const options = [...updated[questionIndex][key]];
      [options[optionIndex - 1], options[optionIndex]] = [
        options[optionIndex],
        options[optionIndex - 1],
      ];
      updated[questionIndex] = { ...updated[questionIndex], [key]: options };
      return updated;
    });
  };

  const moveOptionDown = (questionIndex, optionIndex, key) => {
    setQuestions((prev) => {
      const updated = [...prev];
      const options = [...updated[questionIndex][key]];
      if (optionIndex === options.length - 1) return prev;
      [options[optionIndex + 1], options[optionIndex]] = [
        options[optionIndex],
        options[optionIndex + 1],
      ];
      updated[questionIndex] = { ...updated[questionIndex], [key]: options };
      return updated;
    });
  };

  const deleteOption = (questionIndex, optionIndex, key) => {
    setQuestions((prev) => {
      const updated = [...prev];
      const options = updated[questionIndex][key];
      if (options.length <= 1) return prev;
      updated[questionIndex] = {
        ...updated[questionIndex],
        [key]: options.filter((_, i) => i !== optionIndex),
      };
      return updated;
    });
  };

  const addNewOptions = (questionIndex, optionKey) => {
    setQuestions((prev) => {
      const updated = [...prev];
      const options = updated[questionIndex][optionKey] || [];
      updated[questionIndex] = {
        ...updated[questionIndex],
        [optionKey]: [...options, ""],
      };
      return updated;
    });
  };

  const SurveyValidation = Yup.object().shape({
    Title: Yup.string().required("Title is required."),
    ClosureDate: Yup.string(),
    Desc: Yup.string(),
  });

  const surveyForm = useFormik({
    initialValues: {
      Title: "",
      Desc: "",
      ClosureDate: new Date(),
    },
    validationSchema: SurveyValidation,
    onSubmit: () => { },
  });

  const getValidDate = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return new Date(); // fallback to now if invalid
    return d;
  };

  const saveAll = async () => {
    if (isSavingRef.current) return;

    isSavingRef.current = true;
    setIsloading(true);

    try {
      // 1️⃣ Save survey header
      const { Title, Desc, ClosureDate } = surveyForm.values;
      if (!Title?.trim()) return;
      const headerRes = await addSurveyForm({
        Id: surveyFormId || 0,
        Title: Title.trim(),
        Desc: Desc?.trim() || "",
        ClosureDate: getValidDate(ClosureDate),
        ReferenceId: 0,
      });

      let formId = surveyFormId;
      if (!surveyFormId && headerRes?.Data) {
        formId = headerRes.Data?.Id;
        setSurveyFormId(formId);
        setSurveyFormGuid(headerRes.Data?.GUID);
      }

      // 2️⃣ Save questions
      for (const question of questions) {
        const optionKey = optionKeyByType[question.type];
        const options = (question[optionKey] || [])
          .filter((o) => o?.trim())
          .map((text, i) => ({
            OrgId: userDetails.OrgId,
            OptionText: text.trim(),
            OptionOrder: i + 1,
          }));

        await addSurveyFormQuestion({
          QuestionId: question.serverId || 0,
          FormId: formId,
          OrgId: userDetails.OrgId,
          QuesOrderId: question.order,
          QuestionTitle: question.title || "Untitled",
          QuestionType: question.type,
          IsMandatory: question.required,
          Options: options,
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      isSavingRef.current = false;
      setIsloading(false);
    }
  };



  // Inside your component
  const saveSurvey = async () => {
    if (isSavingRef.current) return;
    isSavingRef.current = true;
    try {
      const { Title, Desc, ClosureDate } = surveyForm.values;
      if (!Title?.trim()) return;
      const res = await addSurveyForm({
        Id: surveyFormId || 0,
        Title: Title.trim(),
        Desc: Desc?.trim() || "",
        ClosureDate: (ClosureDate ?? new Date()).toISOString(),
        ReferenceId: 0,
      });

      if (!surveyFormId && res?.Data) {
        setSurveyFormId(res.Data?.Id);
        setSurveyFormGuid(res.Data?.GUID);
      }
    } finally {
      isSavingRef.current = false;
    }
  };

  const handlePreview = () => {
    history.push(`/Survey/Preview/${surveyFormGuid}`);
  };
  useEffect(() => {
    let timer;
    const handleDocumentClick = (event) => {
      if (activeIndex === null) return;

      if (!event.target.closest(".add-survay-area")) {
        timer = setTimeout(() => {
          setActiveIndex(null);
        }, 200); // 200ms delay
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
      clearTimeout(timer);
    };
  }, [activeIndex]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        e.target.closest("input") ||
        e.target.closest("textarea") ||
        e.target.closest("select") ||
        e.target.closest("button")
      ) {
        return;
      }

      if (
        surveyWrapperRef.current &&
        surveyWrapperRef.current.contains(e.target)
      ) {
        return;
      }

      clearTimeout(saveTimeoutRef.current);
      saveTimeoutRef.current = setTimeout(() => {
        saveSurvey();
      }, 400);
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      clearTimeout(saveTimeoutRef.current);
    };
  }, [surveyForm.values, surveyFormId]);

  useEffect(() => {
    if (!lastEditedQuestionId) return;
    const q = questions.find((x) => x.id === lastEditedQuestionId);
    if (q) debouncedSaveQuestion(q);
  }, [questions, lastEditedQuestionId, debouncedSaveQuestion]);


  const saveSurveyHeader = async () => {
    if (!surveyForm.values.Title?.trim()) return;

    const res = await addSurveyForm({
      Id: surveyFormId || 0,
      Title: surveyForm.values.Title,
      Desc: surveyForm.values.Desc || "",
      ClosureDate: (surveyForm.values.ClosureDate ?? new Date()).toISOString(),
      ReferenceId: 0,
    });

    if (!surveyFormId && res?.Data) {
      setSurveyFormId(res.Data?.Id);
      setSurveyFormGuid(res.Data?.GUID);
    }
  };


  useEffect(() => {
    if (!lastEditedQuestionId) return;
    const q = questions.find((x) => x.id === lastEditedQuestionId);
    if (q) debouncedSaveQuestion(q);
  }, [questions, lastEditedQuestionId, debouncedSaveQuestion]);


  const handlePublish = async () => {
    if (!surveyFormId || !userDetails.EmpId) return;

    try {
      setIsPublishing(true);
      await publishUnpublishSurveyForm({
        FormId: surveyFormId,
        LoggedInUserId: userDetails.EmpId,
      });
      loadExistingSurvey();
      history.push("/Survey/List")
    } catch (error) {
      console.error("Publish failed", error);
    } finally {
      setIsPublishing(false);
    }
  };



  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        surveyWrapperRef.current &&
        !surveyWrapperRef.current.contains(e.target)
      ) {
        saveAll();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [questions, surveyForm.values]);


  const isQuestionValid = (q) => {
  if (!q.title || q.title.trim() === "") return false;

  if (q.type === 101) {
    return q.optionsCheckbox.some(opt => opt.trim() !== "");
  }

  if (q.type === 102) {
    return q.optionsRadio.some(opt => opt.trim() !== "");
  }

  if (q.type === 103) {
    return q.optionsDropdown.some(opt => opt.trim() !== "");
  }

  return true; 
};


   const isQuestionTitleFilled = (q) => {
  return q.title && q.title.trim() !== "";
};

  // const hasValidQuestion = questions.some(q => isQuestionValid(q));

  const lastQuestion = questions[questions.length - 1];
const hasValidQuestion = lastQuestion && isQuestionTitleFilled(lastQuestion);




  return (
    <div>
      <div className="container-fluid   position-relative">
        <div className="row team-directories g-3">
          <div className="survay-block-area">
            <div className="row justify-content-center" ref={surveyWrapperRef}>
              <div className="col-lg-11">
                <form
                  onSubmit={surveyForm.handleSubmit}
                  ref={formRef}
                  onClick={() => setIsEditing(true)}
                >
                  <div className="form-head d-flex flex-wrap align-items-center mb-3">
                    <div className="me-auto">
                      <h3 className="font-w600 mb-0">
                        {SurveyFormId ? "Survey Update" : "Survey Create"}
                      </h3>
                    </div>

                    <div className="rightside-tabs">
                      <div>
                        <Calendar
                          id="calendar-12h"
                          className="me-2"
                          value={surveyForm.values.ClosureDate}
                          onChange={(e) => {
                            surveyForm.setFieldValue("ClosureDate", e.value);
                          }}
                        />
                      </div>
                      {surveyFormId && (<button
                        className="btn-light me-2"
                        type="button"
                        onClick={() => handlePreview()}
                      >
                        Preview
                      </button>)}
                      <button
                        className={`btn ${surveyStatus ? "btn-success" : "btn-purple"
                          }`}
                        disabled={!surveyFormId || isPublishing}
                        onClick={handlePublish}
                      >
                        {isPublishing
                          ? "Please wait..."
                          : surveyStatus
                            ? "Unpublish"
                            : "Publish"}
                      </button>
                      {/* <button
                        className={`btn ${surveyFormId ? "btn-primary" : surveyStatus ? "btn-success" : "btn-purple"}`}
                        disabled={!surveyFormId || isPublishing}
                        onClick={handlePublish}
>
                       {isPublishing
                       ? "Please wait..."
                  : surveyFormId
                   ? "Update"
                   : surveyStatus
                   ? "Unpublish"
                   : "Publish"}
                </button> */}
                      <Link to="/Survey/List">
                        <button
                          className="add-newticket w-auto float-right"
                          style={{ minWidth: "fit-content" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-arrow-left-short"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                            />
                          </svg>
                          Back
                        </button>
                      </Link>
                    </div>
                  </div>
                  {isEditing ? (
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="edit-title-heading-area">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  name="Title"
                                  maxLength={150}
                                  className={
                                    "form-control titleinput" +
                                    (surveyForm.errors.Title &&
                                      surveyForm.touched.Title
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder="Survey title"
                                  value={surveyForm.values.Title}
                                  onChange={surveyForm.handleChange}
                                  onBlur={() => {
                                    surveyForm.handleBlur({ target: { name: "Title" } });
                                    if (surveyForm.values.Title?.trim()) {
                                      saveSurveyHeader();
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div>
                                <input
                                  type="text"
                                  className={
                                    "form-control" +
                                    (surveyForm.errors.Desc &&
                                      surveyForm.touched.Desc
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="Desc"
                                  placeholder="Description"
                                  value={surveyForm.values.Desc}
                                  onChange={surveyForm.handleChange}
                                  onBlur={() => {
                                    surveyForm.handleBlur({ target: { name: "Desc" } });
                                    if (surveyForm.values.Title?.trim()) {
                                      saveSurveyHeader();
                                    }
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="edit-title-heading-area">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="mb-3">
                                <h1>
                                  {surveyForm.values.Title || "Survey title"}
                                </h1>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div>
                                <p>
                                  {surveyForm.values.Desc ||
                                    "Survey Description"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </form>

              </div>

              <div className="col-lg-11">
                <div className="card add-surveycard">
                  {questions.map((q, index) => {
                    const isActive = activeIndex === index;
                    const optionKey = optionKeyByType[q.type] || "optionsInput";
                    return (
                      <div
                        className={`add-survay-area ${activeIndex === index ? "active-survey-area" : ""}`}
                        key={q.id}
                        data-index={q.order}
                        onClick={() => setActiveIndex(index)}
                      >
                        <div className="card-body">
                          <div className="question-survay-area">
                            <div className="question-num">Q{index + 1}.</div>
                            <div className="enter-question-area">
                              {isActive ? (
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={q.title}
                                    autoFocus
                                    onChange={(e) =>
                                      updateQuestion(
                                        q.id,
                                        "title",
                                        e.target.value,
                                      )
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </div>
                              ) : (
                                <div className="py-2 px-3">
                                  <strong>
                                    {/* {q.title
                                       ? q.title
                                       : surveyFormGuid
                                      ? "Click to edit question"
                                       : "Click to add question"} */}

                                       {q.title ? q.title : SurveyFormId ? "Click to edit question" : "Click to add question"}
                                  </strong>
                                </div>
                              )}
                            </div>
                          </div>

                          {q.type === 101 && (
                            <div className="selected-options-area">
                              {q.optionsCheckbox.map((opt, i) => (



                                <div className="option-notes-survay" key={i}>
                                  <div className="form-check d-flex align-items-center">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name={`q-${q.id}`}
                                      required={q.required}
                                      placeholder="Please enter checkbox"
                                      disabled
                                    />
                                    {isActive ? (
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={opt}
                                        placeholder="Option text"
                                        onChange={(e) =>
                                          updateOption(
                                            q.id,
                                            i,
                                            e.target.value,
                                            optionKey,
                                          )
                                        }
                                        onClick={(e) => e.stopPropagation()}
                                      />
                                    ) : (
                                      <div className="py-2 px-3">
                                        <strong>{opt}</strong>
                                      </div>
                                    )}
                                  </div>

                                  {isActive && (
                                    <div className="survey-actions">
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteOption(
                                            index,
                                            i,
                                            "optionsCheckbox",
                                          );
                                          setLastEditedQuestionId(q.id);
                                        }}
                                      // onClick={() => deleteSurevyQuestions()}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-trash"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        disabled={i === 0}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          moveOptionUp(
                                            index,
                                            i,
                                            "optionsCheckbox",
                                          );
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-arrow-up"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
                                          />
                                        </svg>
                                      </button>

                                      <button
                                        type="button"
                                        disabled={
                                          i === q.optionsCheckbox.length - 1
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          moveOptionDown(
                                            index,
                                            i,
                                            "optionsCheckbox",
                                          );
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-arrow-down"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ))}

                              {isActive && (
                                <div className="">
                                  <button
                                    className="Add-new-box btn-link"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addNewOptions(index, "optionsCheckbox");
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-plus-circle me-2"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                    </svg>{" "}
                                    Add New Options
                                  </button>
                                </div>
                              )}
                            </div>
                          )}

                          {q.type === 102 && (
                            <div className="selected-options-area">
                              {q.optionsRadio.map((opt, i) => (
                                <div className="option-notes-survay" key={i}>
                                  <div className="form-check">
                                    {/* <input
                                      className="form-check-input"
                                      type="radio"
                                      name={`q-${q.id}`}
                                      required={q.required}
                                      placeholder="Please enter Radio"
                                      disabled
                                    /> */}
                                    {isActive && (
                                      <input
                                       className="form-check-input"
                                       type="radio"
                                       name={`q-${q.id}`}
      required={q.required}
      disabled
    />
  )}

                                    {isActive ? (
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={opt}
                                        placeholder="Option text"
                                        onChange={(e) =>
                                          updateOption(
                                            q.id,
                                            i,
                                            e.target.value,
                                            optionKey,
                                          )
                                        }
                                        onClick={(e) => e.stopPropagation()}
                                      />
                                    ) : (
                                      <div className="py-2 px-3">
                                        <strong>{opt}</strong>
                                      </div>
                                    )}
                                  </div>

                                  {isActive && (
                                    <div className="survey-actions">
                                      <button
                                        className=""
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteOption(
                                            index,
                                            i,
                                            "optionsRadio",
                                          );
                                          setLastEditedQuestionId(q.id);
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-trash"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                      </button>
                                      <button
                                        className=""
                                        type="button"
                                        disabled={i === 0}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          moveOptionUp(
                                            index,
                                            i,
                                            "optionsRadio",
                                          );
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-arrow-up"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
                                          />
                                        </svg>
                                      </button>
                                      <button
                                        className=""
                                        type="button"
                                        disabled={i === q.optionsRadio.length - 1}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          moveOptionDown(
                                            index,
                                            i,
                                            "optionsRadio",
                                          );
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-arrow-down"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ))}

                              {isActive && (
                                <div className="">
                                  <button
                                    className="Add-new-box"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addNewOptions(index, "optionsRadio");
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-plus-circle me-2"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                    </svg>{" "}
                                    Add New Options
                                  </button>
                                </div>
                              )}
                            </div>
                          )}

                          {q.type === 103 && (
                            <div className="selected-options-area">
                              {/* Dropdown preview */}
                              <select
                                className="form-select mb-2 select-drop-option"
                                disabled
                              >
                                {q.optionsDropdown.map((opt, i) => (
                                  <option key={i}>{opt}</option>
                                ))}
                              </select>

                              {/* Editable options */}
                              {q.optionsDropdown.map((opt, i) => (


                                <div className="option-notes-survay" key={i}>
                                  {isActive ? (
                                    <input
                                      type="text"
                                      className="form-control form-control-sm dropselect"
                                      value={opt}
                                      placeholder="Option text"
                                      onChange={(e) =>
                                        updateOption(
                                          q.id,
                                          i,
                                          e.target.value,
                                          optionKey,
                                        )
                                      }
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  ) : (
                                    <div className="py-2 px-3">
                                      <strong>{opt}</strong>
                                    </div>
                                  )}

                                  {/* {isActive && (
                                    <div className="survey-actions">
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteOption(
                                            index,
                                            i,
                                            "optionsDropdown",
                                          );
                                          moveOptionUp(
                                            index,
                                            i,
                                            "optionsDropdown",
                                          );
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-trash"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        disabled={i === 0}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteOption(
                                            index,
                                            i,
                                            "optionsDropdown",
                                          );
                                          moveOptionUp(
                                            index,
                                            i,
                                            "optionsDropdown",
                                          );
                                        }}
                                      >
                                        ↑
                                      </button>

                                      <button
                                        type="button"
                                        disabled={
                                          i === q.optionsDropdown.length - 1
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteOption(
                                            index,
                                            i,
                                            "optionsDropdown",
                                          );
                                          moveOptionDown(
                                            index,
                                            i,
                                            "optionsDropdown",
                                          );
                                        }}
                                      >
                                        ↓
                                      </button>
                                    </div>
                                  )} */}
                                  {isActive && (
  <div className="survey-actions">
    
    
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        deleteOption(index, i, "optionsDropdown"); 
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-trash"
        viewBox="0 0 16 16"
      >
        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
      </svg>
    </button>

    
    <button
      type="button"
      disabled={i === 0}
      onClick={(e) => {
        e.stopPropagation();
        moveOptionUp(index, i, "optionsDropdown"); 
      }}
    >
      ↑
    </button>

    {/* 🔽 MOVE DOWN */}
    <button
      type="button"
      disabled={i === q.optionsDropdown.length - 1}
      onClick={(e) => {
        e.stopPropagation();
        moveOptionDown(index, i, "optionsDropdown"); 
      }}
    >
      ↓
    </button>

  </div>
)}
                                </div>
                              ))}

                              {isActive && (
                                <div className="">
                                  <button
                                    className="Add-new-box btn btn-link "
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addNewOptions(index, "optionsDropdown");
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="19"
                                      height="19"
                                      fill="currentColor"
                                      className="bi bi-plus-circle me-2"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                    </svg>{" "}
                                    Add New Options
                                  </button>
                                </div>
                              )}
                            </div>
                          )}

                          {q.type === 104 && (
                            <div className="selected-options-area">
                              {/* {q.optionsInput.map((opt, i) => ( */}

                              {q.optionsInput.map((opt, i) => (
                                <div className="option-notes-survay" key={i}>
                                  {isActive ? (
                                    <input
                                      type="text"
                                      className="form-control textinputdiv"
                                      disabled
                                      placeholder={opt}
                                      value={opt}
                                      required={isRequired}
                                      onChange={(e) =>
                                        updateOption(
                                          q.id,
                                          i,
                                          e.target.value,
                                          optionKey,
                                        )
                                      }
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  ) : (
                                    <div className="py-2 px-3">
                                      <strong>{opt}</strong>
                                    </div>
                                  )}

                                  {isActive && (
                                    <div className="survey-actions">
                                      {/* <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          deleteOption(
                                            index,
                                            i,
                                            "optionsInput",
                                          );
                                          setLastEditedQuestionId(q.id);
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-trash"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                        </svg>
                                      </button> */}
                                      {/* <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          moveOptionUp(
                                            index,
                                            i,
                                            "optionsInput",
                                          );
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-arrow-up"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
                                          ></path>
                                        </svg>
                                      </button>

                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          moveOptionDown(
                                            index,
                                            i,
                                            "optionsInput",
                                          );
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-arrow-down"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                                          ></path>
                                        </svg>
                                      </button> */}
                                    </div>
                                  )}
                                </div>
                              ))}

                              {/* {isActive && (
                                <div className="">
                                  <button
                                    className="Add-new-box btn btn-link "
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addNewOptions(index, "optionsInput");
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="19"
                                      height="19"
                                      fill="currentColor"
                                      className="bi bi-plus-circle me-2"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                    </svg>{" "}
                                    Add New Options
                                  </button>
                                </div>
                              )} */}
                            </div>
                          )}
                        </div>

                        {isActive && (
                          <div className="card-footer">
                            <div className="survay-icon d-flex justify-content-end align-items-center">
                              <select
                                className="form-select"
                                value={q.type}
                                onChange={(e) =>
                                  updateQuestion(
                                    q.id,
                                    "type",
                                    Number(e.target.value),
                                  )
                                }
                                onClick={(e) => e.stopPropagation()}
                              >
                                <option value="">Select Question Type</option>

                                {surveyOptionType?.map((item) => (
                                  <option key={item.Id} value={item.Id}>
                                    {item.Name}
                                  </option>
                                ))}
                              </select>

                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="flexSwitchCheckDefault"
                                  checked={q.required}
                                  onChange={(e) =>
                                    updateQuestion(
                                      q.id,
                                      "required",
                                      e.target.checked,
                                    )
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                />

                                <label
                                  className="form-check-label"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  Required
                                </label>
                              </div>

                              <button
                                className="btn btn-link "
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  copyQuestion(index);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-copy"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                                  />
                                </svg>
                              </button>
                              <button
                                className="btn btn-link"
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteQuestion(index, q);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-trash"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                </svg>
                              </button>
                              {/* <button
                                className="btn btn-link "
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  moveQuestionDown(index);
                                }}
                              > */}
                                
                                <button
                                className="btn btn-link "
                                type="button"
                                disabled={index === questions.length - 1}
                                onClick={(e) => {
                                e.stopPropagation();
                               moveQuestionDown(index);
                               }}
                               >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-arrow-down"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                                  />
                                </svg>
                              </button>
                              {/* <button
                                className="btn btn-link me-2"
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  moveQuestionUp(index);
                                }}
                              > */}

                              <button
                               className="btn btn-link me-2"
                               type="button"
                               disabled={index === 0}
                               onClick={(e) => {
                               e.stopPropagation();
                               moveQuestionUp(index);
                               }}
                               >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-arrow-up"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              


              {hasValidQuestion && (
                <div className="">
                  <button
                    className="Add-new-box btn btn-link p-0 "
                    onClick={handleAddNewQuestion}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19"
                      fill="currentColor"
                      className="bi bi-plus-circle me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                    </svg>{" "}
                    Add New Questions
                  </button>
                </div>
              )}


              </div>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default CreateSurvay;
